import { FC, SVGProps } from 'react';

export enum IconSize {
  XS = 'extraSmall',
  S = 'small',
  M = 'medium',
  L = 'large',
  XL = 'extraLarge',
  AUTO = 'auto',
}

export type IconProps = {
  icon: FC<SVGProps<SVGElement>>;
  color?: string;
  reverse?: boolean;
  size?: IconSize;
};
